import { useMemo, useState } from "react";
import { Search, UsersRound, X } from "lucide-react";
import DateRangePicker from "../../../../ecommerce/globalcomponents/DateRangePicker";
import AusCommTable from "./AusCommTable";
import { loyaltyReferralIncentivesData } from "../sponsorcommission/loyaltyReferralIncentivesData";
import { formatEarningsCurrency } from "../earningsAdapters";
import "./LoyaltyReferralIncentives.css";

const AusComm = () => {
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [dateRange, setDateRange] = useState({ from: "", to: "" });

  const filteredRecords = useMemo(() => {
    const query = searchValue.trim().toLowerCase();
    return loyaltyReferralIncentivesData.filter(
      (record) =>
        (!query ||
          record.partnerNetworkId.toLowerCase().includes(query) ||
          record.partnerNetworkName.toLowerCase().includes(query) ||
          record.status.toLowerCase().includes(query)) &&
        (!dateRange.from || record.date >= dateRange.from) &&
        (!dateRange.to || record.date <= dateRange.to),
    );
  }, [searchValue, dateRange]);

  const totalPages = Math.max(
    1,
    Math.ceil(filteredRecords.length / pageSize),
  );
  const page = Math.min(currentPage, totalPages);
  const visibleRecords = filteredRecords.slice(
    (page - 1) * pageSize,
    page * pageSize,
  );
  const totalReceived = filteredRecords.reduce(
    (total, record) => total + record.receivedIncentive,
    0,
  );

  return (
    <section className="loyalty-referral-page">
      <div className="loyalty-referral-shell">
        <header className="loyalty-referral-header">
          <div className="loyalty-referral-heading">
            <span className="loyalty-referral-heading-icon">
              <UsersRound size={24} strokeWidth={2} />
            </span>
            <div>
              <span className="loyalty-referral-kicker">
                LOYALTY REFERRAL INCENTIVES
              </span>
              <h1>Loyalty Refferal Commission</h1>
              <p>
                Track loyalty referral earnings, partner network activity
                and incentive status.
              </p>
            </div>
          </div>

          <div className="loyalty-referral-summary">
            <span>Total Received</span>
            <strong>{formatEarningsCurrency(totalReceived)}</strong>
          </div>
        </header>

        <div className="loyalty-referral-toolbar">
          <select
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
              setCurrentPage(1);
            }}
            aria-label="Entries per page"
          >
            <option value={5}>5 Entries</option>
            <option value={10}>10 Entries</option>
            <option value={20}>20 Entries</option>
          </select>

          <div className="loyalty-referral-date-picker">
            <DateRangePicker
              value={dateRange}
              onChange={(v) => {
                setDateRange(v);
                setCurrentPage(1);
              }}
            />
          </div>

          <div className="loyalty-referral-search">
            <Search size={18} strokeWidth={2} />
            <input
              type="search"
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
                setCurrentPage(1);
              }}
              placeholder="Search loyalty incentives..."
              aria-label="Search loyalty referral incentives"
            />
            {searchValue && (
              <button
                type="button"
                onClick={() => setSearchValue("")}
                aria-label="Clear search"
              >
                <X size={16} />
              </button>
            )}
          </div>
        </div>

        <AusCommTable rows={visibleRecords} />

        {totalPages > 1 && (
          <footer className="loyalty-referral-pagination">
            <button
              type="button"
              disabled={page === 1}
              onClick={() => setCurrentPage(page - 1)}
              aria-label="Previous page"
            >
              ‹
            </button>
            <span>
              Page <strong>{page}</strong> of <strong>{totalPages}</strong>
            </span>
            <button
              type="button"
              disabled={page === totalPages}
              onClick={() => setCurrentPage(page + 1)}
              aria-label="Next page"
            >
              ›
            </button>
          </footer>
        )}
      </div>
    </section>
  );
};

export default AusComm;
